import { env, env as remoteEnv } from '@zyb/env';

const ua = navigator.userAgent;
const browser = {
  chrome: function (): number | undefined {
    return /\b(?:Chrome|CriOS)\/(\d+)/i.test(ua) ? +RegExp.$1 : undefined;
  },
  firefox: function (): number | undefined {
    return /\bFirefox\/(\d+)/i.test(ua) ? +RegExp.$1 : undefined;
  },
  safari: function (): number | undefined {
    return /\bSafari\/?(\d+)?/i.test(ua) && !/chrome/i.test(ua) ? +(RegExp.$1 || RegExp.$2) : undefined;
  },
  isStandard: function (): boolean {
    return document.compatMode === 'CSS1Compat';
  },
  isGecko: function (): boolean {
    return /gecko/i.test(ua) && !/like gecko/i.test(ua);
  },
  isWebkit: function (): boolean {
    return /webkit/i.test(ua);
  },
  os: function (): string {
    let os = 'other';
    if (/\bMac/i.test(ua)) {
      if (/iPhone/i.test(ua)) {
        os = 'iphone os_' + (/iPhone OS (\d+(?:_\d+)?)/i.test(ua) ? RegExp.$1.replace('_', '.') : 'unknown');
      } else if (/iPad/i.test(ua)) {
        os = 'ipad os_' + (/iPad.*OS (\d+(?:_\d+)?)/i.test(ua) ? RegExp.$1.replace('_', '.') : 'unknown');
      } else {
        os = 'mac os_' + (/Mac OS X (\d+(?:_\d+)?)/i.test(ua) ? RegExp.$1.replace('_', '.') : 'unknown');
      }
    } else if (/Android/i.test(ua)) {
      os = 'android os_' + (/Android (\d+(?:\.\d+)?)/i.test(ua) ? RegExp.$1 : 'unknown');
    } else if (/\bWindows/i.test(ua)) {
      os =
        'windows os_' +
        (/Windows NT (\d+)/i.test(ua) ? RegExp.$1 : 'unknown') +
        '_' +
        (/win64|x64|wow64/i.test(ua) ? '64' : '32') +
        'bit';
    }
    return os;
  },
  kernel: function (): string {
    let browser = 'other';
    if (this.chrome()) {
      browser = 'chrome_' + this.chrome();
    } else if (this.safari()) {
      browser = 'safari_' + this.safari();
    } else if (this.firefox()) {
      browser = 'firefox_' + this.firefox();
    }
    return browser;
  },

  // 安卓 chrome 浏览器，包含 原生chrome浏览器、三星自带浏览器、360浏览器以及早期国内厂商自带浏览器
  isOriginalChrome(): boolean {
    return (
      /chrome\/[\d.]+ mobile safari\/[\d.]+/i.test(remoteEnv.userAgent) &&
      env.isAndroid &&
      remoteEnv.userAgent.indexOf('Version') < 0
    );
  },

  // 获取微信版本号
  getWeChatVersion: (): string => {
    const version = navigator.appVersion.match(/micromessenger\/(\d+\.\d+\.\d+)/i) as string[];
    return version[1];
  },
  // 比对两个版本，如果版本1>版本2，返回1;否则返回-1
  semverCompare: (verionA: string, versionB: string): number => {
    const { isNaN } = window;
    const splitA = verionA.split('.');
    const splitB = versionB.split('.');

    for (let i = 0; i < 3; i++) {
      const snippetA = Number(splitA[i]);
      const snippetB = Number(splitB[i]);
      if (snippetA > snippetB) return 1;
      if (snippetB > snippetA) return -1;
      // e.g. '1.0.0-rc' -- Number('0-rc') = NaN
      if (!isNaN(snippetA) && isNaN(snippetB)) return 1;
      if (isNaN(snippetA) && !isNaN(snippetB)) return -1;
    }
    return 0;
  }
};

export default browser;
